module.exports = __webpack_public_path__ + "img/CM-BS-25-BMW-Modern.46dc6c3a.jpg";